export default {
  mainTitle: {
    id: 'review_main_title',
    defaultMessage: 'Value for money',
  },
  mainSubtitle: {
    id: 'review_main_subtitle',
    defaultMessage: 'How would you rate your product?',
  },
  mainVisitedTitle: {
    id: 'review_main_visited_title',
    defaultMessage: 'Change your rating?',
  },
  mainVisitedSubtitle: {
    id: 'review_main_visited_subtitle',
    defaultMessage:
      'What did you think of its value in terms of quality-price?',
  },
  accessoriesTitle: {
    id: 'review_accessories_title',
    defaultMessage: 'Accessories',
  },
  accessoriesSubtitle: {
    id: 'review_accessories_subtitle',
    defaultMessage:
      'Did the product come with accessories and are they in good shape?',
  },
  aestheticAppearanceTitle: {
    id: 'review_aesthetic_appearance_title',
    defaultMessage: 'Outside Appearance',
  },
  aestheticAppearanceSubtitle: {
    id: 'review_aesthetic_appearance_subtitle',
    defaultMessage:
      'Did the appearance of the product you received match the grade selected?',
  },
  batteryTitle: {
    id: 'review_battery_title',
    defaultMessage: 'Battery',
  },
  batterySubtitle: {
    id: 'review_battery_subtitle',
    defaultMessage: 'Is battery life sufficient for normal use?',
  },
  cameraTitle: {
    id: 'review_camera_title',
    defaultMessage: 'Lens & Camera',
  },
  cameraSubtitle: {
    id: 'review_camera_subtitle',
    defaultMessage: 'Are the lens and camera working',
  },
  overallPerformanceTitle: {
    id: 'review_overall_performance_title',
    defaultMessage: 'Overall performance',
  },
  overallPerformanceSubtitle: {
    id: 'review_overall_performance_subtitle',
    defaultMessage: 'Does the product function as expected?',
  },
  packagingCleanlinessTitle: {
    id: 'review_packaging_cleanliness_title',
    defaultMessage: 'Packaging and cleanliness',
  },
  packagingCleanlinessSubtitle: {
    id: 'review_packaging_cleanliness_subtitle',
    defaultMessage: 'Was the product clean and intact in the packaging?',
  },
  shippingTitle: {
    id: 'review_shipping_title',
    defaultMessage: 'Shipping',
  },
  shippingSubtitle: {
    id: 'review_shipping_subtitle',
    defaultMessage: 'Was the delivery time provided accurate?',
  },
}
